import { ShiftPatternEntry } from "@app/services/http/availability-service/shift-pattern.entry";
import { ConflictResolution } from "@app/services/http/availability-service/conflict.resolution";

export class AvailabilityBulkRequest {
  resources: number[];
  availabilityCodeId: number;
  note: string;
  pattern: ShiftPatternEntry[];
  length: number;
  originDate: Date;
  startDate: Date;
  endDate: Date;
  conflictResolutions: ConflictResolution[];
  commit: boolean;
  defaultAction: boolean;
  cyclicalPriorityReservation: number;
  normalPriorityReservation: number;
  highPriorityReservation: number;
  emergencyPriorityReservation: number;
}
